import React from 'react';

// React Router Dom
import { Link } from 'react-router-dom';

// Local Components
import SuccessSvg from '../../assets/images/SuccessCheck.svg';
import EventDetailBanner from '../EventMetaDescription/EventDetailBanner';
import TermsAndConditon from '../UiComponent/TermsAndConditon';
import AttendeeTicketDetails from './AttendeeTicketDetails';
import EventShareSection from '../UiComponent/EventShareSection';
import EventBySection from '../UiComponent/EventBySection';
import EventSchedule from '../UiComponent/EventSchedule';
import VenueMapLocation from '../UiComponent/VenueMapLocation';
import SpanTag from '../FormFields/SpanTag';
import UserTicket from '../EventTicketDetails/UserTicket';
import UserPurchaseTicket from '../../view/application/ticket-booking/UserPurchaseTicket';

// Events Data
import EventData from '../../data/eventsData.json';

// Utils
import { formatEventDate } from '../../utils/dateFormatter';

// Buttons
import { PrimaryBtn } from '../Buttons/Buttons';

// Typography
import { H4, H5, Body1, Body2, Body3 } from '../../themes/typography';

// CSS Styles
import '../../styles/components/TicketBooked.css';

// Success Message Container
function TicketSuccessMessage() {
    return (
        <section className="success-text-section">
            <div className="success-svg">
                <img src={SuccessSvg} alt="Success Svg" />
            </div>
            <div className="success-text">
                <H4>Thank You! Your Booking is Confirmed</H4>
                <Body1>Your Tickets have been successfully booked.</Body1>
            </div>
        </section>
    );
}

// Ticket Sent Text
function TicketSentText() {
    return (
        <section className="ticket-booked-text-section">
            <H5>Ticket Details</H5>
            <Body2>
                We have sent your order confirmation to email@gmail.com. Tickets are on the way to
                the email id's of the attendees provided previously.
            </Body2>
            <Body3>
                Please check your spam folder in case you do not find the ticket in your inbox. Also
                please mark it “Not Spam”.
            </Body3>
        </section>
    );
}

function getCategorySubCategoryFormat() {
    return (
        <React.Fragment>
            <SpanTag eventFormatTag={singleEvent.eventCategory} />
            <SpanTag eventFormatTag={singleEvent.eventSubcategory[0]} />
            <SpanTag eventFormatTag={singleEvent.eventFormat[0]} />
        </React.Fragment>
    );
}

// This function is used to get the event date based on the eventDate.type values and return the formatted date string.
function getEventDate() {
    if (singleEvent.eventDate.type === 'Single Date') {
        return formatEventDate(singleEvent.eventDate.date); // If the eventDate.type is 'Single Date', then return the single formatted date.
    } else if (singleEvent.eventDate.type === 'Multiple Dates') {
        return (
            formatEventDate(singleEvent.eventDate.date) +
            ' - ' +
            formatEventDate(singleEvent.eventDate.endDate)
        ); // If the eventDate.type is 'Multiple Dates', then return the formatted date range with "-".
    } else {
        return (
            formatEventDate(singleEvent.eventDate.date) +
            ' to ' +
            formatEventDate(singleEvent.eventDate.endDate)
        ); // Else the eventDate.type is 'Date Range', then return the formatted date range with "to".
    }
}

function getEventDuration() {
    if (
        singleEvent.eventDate.type === 'Date Range' &&
        singleEvent.eventSchedule.days[0].slots.length === 0
    ) {
        return singleEvent.eventDuration; // show the event duration if the event is of type 'Date Range' and 'Single Date without slot'
    } else if (singleEvent.eventDate.type === 'Single Date') {
        if (singleEvent.eventSchedule.days[0].slots.length > 1) {
            return (
                <React.Fragment>
                    <div style={{ display: 'flex', gap: '5px' }}>
                        <Body2>Multiple Slots</Body2>
                        <Body2
                            color="#26C1E8"
                            style={{ cursor: 'pointer' }}
                            onClick={scrollToEventSchedule}
                        >
                            [View Event Schedule]
                        </Body2>
                    </div>
                </React.Fragment>
            );
        }
    } else {
        return null;
    }
}

function getEventTimeSlot() {
    if (
        singleEvent.eventDate.type === 'Single Date' ||
        singleEvent.eventDate.type === 'Date Range'
    ) {
        return singleEvent.eventStartTime + ' - ' + singleEvent.eventEndTime;
    } else {
        return (
            <div style={{ display: 'flex', gap: '5px' }}>
                <Body2>Multiple Days</Body2>
                <Body2
                    color="#26C1E8"
                    style={{ cursor: 'pointer' }}
                    onClick={scrollToEventSchedule}
                >
                    [View Event Schedule]
                </Body2>
            </div>
        );
    }
}

function getEventSchedule() {
    if (
        singleEvent.eventDate.type === 'Date Range' ||
        (singleEvent.eventDate.type === 'Single Date' &&
            singleEvent.eventSchedule.days[0].slots.length === 0)
    ) {
        return null; // hide eventSchedule if there are no slots available.
    } else {
        return singleEvent.eventSchedule.days; // show eventSchedule if there are slots available.
    }
}

function scrollToEventSchedule() {
    window.scrollTo({
        top: 500,
        behavior: 'smooth'
    });
}

const eventId = 3;

const singleEvent = EventData.find((event) => event.eventId === eventId);

// console.log(singleEvent);

export default function TicketBooked() {
    return (
        <React.Fragment>
            <div className="ticket-booked-page-container">
                {/* Success Message */}
                <TicketSuccessMessage />

                {/* Event Detail Banner */}
                <EventDetailBanner
                    eventThumbnailUrl={singleEvent.eventThumbnailImageUrl}
                    eventName={singleEvent.eventDisplayName}
                    eventLocation={singleEvent.eventLocationName}
                    numberOfTickets={3}
                    orderId={5412697102}
                    eventDate={getEventDate()}
                    eventTimeSlot={getEventTimeSlot()}
                    eventDuration={getEventDuration()}
                    eventCategorySubcategoryFormat={getCategorySubCategoryFormat()}
                    showElipsis={false}
                    eventGetTicketBtn={
                        <Link to="ticket-page" target="_blank">
                            <PrimaryBtn name="View My Tickets" />
                        </Link>
                    }
                />

                <section className="ticket-booked-summary-section">
                    <div className="ticket-centered-container">
                        {/* Ticket Purchase Left Section */}
                        <div className="ticket-booked-left-container">
                            {/* Ticket Sent Text */}
                            <TicketSentText />

                            {/* Attendee Ticket Summary Section */}
                            <div className="attendee-ticket-summary-container">
                                <UserPurchaseTicket />
                                <UserTicket />
                                <UserTicket />
                                <AttendeeTicketDetails />
                                <AttendeeTicketDetails />
                                <AttendeeTicketDetails />
                            </div>

                            {/* Terms and Condition */}
                            <TermsAndConditon />

                            {/* FAQs */}
                            <TermsAndConditon name="FAQs" />
                        </div>

                        {/* Ticket Booked Right Section */}
                        <div className="ticket-booked-right-container">
                            <EventSchedule eventSchedules={getEventSchedule()} />
                            <VenueMapLocation />
                            <EventBySection />
                            <EventShareSection />
                        </div>
                    </div>
                </section>
            </div>
        </React.Fragment>
    );
}
